import React from "react";
import { HomeSection } from "./HomeSection";
import { Box, Button } from "@mui/material";
import { Link } from "react-router-dom";
import { ToolCatalog } from "../tools/ToolCatalog";

export function ToolsSection() {
  return (
    <HomeSection
      id="tools"
      title="Tools"
      description="Practical browser tools for everyday tasks, calculations, and working with data."
    >
      <ToolCatalog limit={8} />
      <Box sx={{ display: "flex", justifyContent: "center", mt: 4 }}>
        <Button component={Link} to="/tools" variant="outlined" size="large">
          View all tools
        </Button>
      </Box>
    </HomeSection>
  );
}
